export interface TranslatedContent {
  navigation: {
    home: string;
    solutions: string;
    assets: string;
    compliance: string;
    insights: string;
    about: string;
    contact: string;
    blog: string;
    press: string;
    clientArea: string;
    login: string;
    ourSolutions: string;
    generalServices: string;
    consulting: string;
    support: string;
    training: string;
    documentation: string;
    api: string;
    partnerships: string;
    aboutSubmenu: {
      overview: string;
      board: string;
      strategy: string;
      governance: string;
    };
  };
  auth: {
    clientArea: string;
    accessAccount: string;
    email: string;
    password: string;
    rememberMe: string;
    forgotPassword: string;
    login: string;
    loggingIn: string;
    continue: string;
    notMe: string;
    showPassword: string;
    hidePassword: string;
    backToWebsite: string;
    twoFactorVerification: string;
    enterCodeFromAuth: string;
    verificationCode: string;
    verifyCode: string;
    verifying: string;
    backToLogin: string;
    recoverPassword: string;
    enterEmailToRecover: string;
    cancel: string;
    send: string;
    sending: string;
    emailSentMessage: string;
  };
  hero: {
    title: string;
    subtitle: string;
    description: string;
    primaryCta: string;
    secondaryCta: string;
  };
  pillars: {
    title: string;
    compliance: {
      title: string;
      description: string;
    };
    curation: {
      title: string;
      description: string;
    };
    liquidation: {
      title: string;
      description: string;
    };
    intelligence: {
      title: string;
      description: string;
    };
  };
  solutions: {
    title: string;
    markets: {
      title: string;
      description: string;
    };
    advisory: {
      title: string;
      description: string;
    };
    origins: {
      title: string;
      description: string;
    };
    logistics: {
      title: string;
      description: string;
    };
    vault: {
      title: string;
      description: string;
    };
    insights: {
      title: string;
      description: string;
    };
    operations: {
      title: string;
      description: string;
    };
  };
  trustSignals: {
    title: string;
    kyc: string;
    custody: string;
    partnerships: string;
    structures: string;
    integration: string;
  };
  dashboard: {
    welcome: string;
    overview: string;
    profile: string;
    settings: string;
    logout: string;
    menu: string;
    work: string;
    projects: string;
    administration: string;
    users: string;
    passwordVault: string;
    system: string;
    tools: string;
    configuration: string;
    chat: string;
    contact: string;
    notifications: string;
    loading: string;
  };
  about: {
    title: string;
    subtitle: string;
    mission: string;
    vision: string;
    values: string;
    team: string;
    history: string;
    certifications: string;
    partnerships: string;
    advisorsTitle: string;
    valuesTitle: string;
    transparency: {
      title: string;
      description: string;
    };
    rigor: {
      title: string;
      description: string;
    };
    security: {
      title: string;
      description: string;
    };
    longTerm: {
      title: string;
      description: string;
    };
  };
  legal: {
    privacyPolicy: string;
    termsOfUse: string;
    cookiePolicy: string;
    legalNotice: string;
    lastUpdated: string;
    effectiveDate: string;
    contactUs: string;
    dataProtection: string;
    cookies: string;
    terms: string;
    liability: string;
    intellectualProperty: string;
    // Terms of Use content
    termsContent: {
      intro: string;
      section1Title: string;
      section1Text: string;
      section2Title: string;
      section2Text: string;
      section2Items: string[];
      section3Title: string;
      section3Text1: string;
      section3Text2: string;
      section3Items: string[];
      section3Text3: string;
      section4Title: string;
      section4Text: string;
      section5Title: string;
      section5_1Title: string;
      section5_1Text: string;
      section5_2Title: string;
      section5_2Text: string;
      section6Title: string;
      section6Text: string;
      section7Title: string;
      section7Text: string;
    };
    // Privacy Policy content
    privacyContent: {
      intro: string;
      section1Title: string;
      section1Text: string;
      section1Items: string[];
      section2Title: string;
      section2Text: string;
      section2Items: string[];
      section3Title: string;
      section3Text: string;
      section4Title: string;
      section4Text: string;
      section5Title: string;
      section5Text1: string;
      section5Text2: string;
      section6Title: string;
      section6Text: string;
      section7Title: string;
      section7Text: string;
    };
    // Legal Notice content
    legalNoticeContent: {
      section1Title: string;
      companyName: string;
      tradeName: string;
      cnpj: string;
      address: string;
      contact: string;
      section2Title: string;
      section2Text: string;
      section3Title: string;
      section3Text: string;
    };
  };
  careers: {
    title: string;
    subtitle: string;
    heroTitle: string;
    heroSubtitle: string;
    missionTitle: string;
    missionText1: string;
    missionText2: string;
    sendResume: string;
    benefits: {
      growth: { title: string; description: string; };
      team: { title: string; description: string; };
      innovation: { title: string; description: string; };
      balance: { title: string; description: string; };
    };
    emailSubject: string;
    emailBody: string;
  };
  overview: {
    title: string;
    subtitle: string;
    ourCommitment: string;
    smartMethodology: string;
    specific: string;
    measurable: string;
    achievable: string;
    relevant: string;
    timeBound: string;
    mission: {
      title: string;
      text: string;
    };
    vision: {
      title: string;
      text: string;
    };
    valuesTitle: string;
    values: {
      financial: { name: string; description: string; };
      human: { name: string; description: string; };
      trust: { name: string; description: string; };
      success: { name: string; description: string; };
      integrated: { name: string; description: string; };
    };
    approach: {
      title: string;
      intro: string;
      footer: string;
      footerEmphasis: string;
    };
    smart: {
      specific: { title: string; subtitle: string; items: string[]; };
      measurable: {
        title: string;
        subtitle: string;
        items: { title: string; description: string; }[];
      };
      achievable: { title: string; subtitle: string; items: string[]; };
      relevant: { title: string; subtitle: string; items: string[]; };
      timeBound: { title: string; subtitle: string; items: string[]; };
    };
  };
  board: {
    title: string;
    subtitle: string;
  };
  strategy: {
    title: string;
    subtitle: string;
    businessModel: string;
  };
  governance: {
    title: string;
    subtitle: string;
    ourCommitment: string;
    principlesTitle: string;
    regulatoryCompliance: string;
    operationalTransparency: string;
    riskManagement: string;
    integrity: string;
  };
  router: {
    comingSoon: string;
    documentation: string;
    support: string;
    partnerships: string;
    insights: string;
    backToHome: string;
    contactUs: string;
  };
  footer: {
    company: string;
    description: string;
    solutions: {
      title: string;
      markets: string;
      advisory: string;
      origins: string;
      logistics: string;
      vault: string;
      operations: string;
      insights: string;
    };
    resources: {
      title: string;
      documentation: string;
      compliance: string;
      insights: string;
      support: string;
    };
    company_info: {
      title: string;
      about: string;
      careers: string;
      partnerships: string;
      news: string;
    };
    contact: {
      title: string;
      email: string;
      phone: string;
      address: string;
      business_hours: string;
    };
    legal: {
      privacy: string;
      terms: string;
      cookies: string;
      disclaimer: string;
    };
    social: {
      linkedin: string;
      x: string;
      instagram: string;
    };
    certifications: {
      title: string;
      iso: string;
      oecd: string;
      kimberley: string;
    };
    copyright: string;
  };
}

interface Translations {
  [key: string]: TranslatedContent;
}

export const translations: Translations = {
  'pt-br': {
    navigation: {
      home: 'Início',
      solutions: 'Soluções',
      assets: 'Ativos',
      compliance: 'Compliance',
      insights: 'Insights',
      about: 'Sobre',
      contact: 'Contato',
      blog: 'Blog',
      press: 'Imprensa',
      clientArea: 'Área do Cliente',
      login: 'Login',
      ourSolutions: 'Nossas Soluções',
      generalServices: 'Serviços Gerais',
      consulting: 'Consultoria Geral',
      support: 'Suporte Técnico',
      training: 'Treinamentos',
      documentation: 'Documentação',
      api: 'API & Integração',
      partnerships: 'Parcerias',
      aboutSubmenu: {
        overview: 'Visão Geral',
        board: 'Conselho',
        strategy: 'Estratégia',
        governance: 'Governança Corporativa',
      },
    },
    auth: {
      clientArea: 'Área do Cliente',
      accessAccount: 'Acesse sua conta',
      email: 'Email',
      password: 'Senha',
      rememberMe: 'Lembrar de mim',
      forgotPassword: 'Esqueci minha senha',
      login: 'Entrar',
      loggingIn: 'Entrando...',
      continue: 'Continuar',
      notMe: 'Não sou eu',
      showPassword: 'Mostrar senha',
      hidePassword: 'Ocultar senha',
      backToWebsite: '← Voltar ao site',
      twoFactorVerification: 'Verificação em Duas Etapas',
      enterCodeFromAuth: 'Digite o código do seu aplicativo autenticador',
      verificationCode: 'Código de Verificação',
      verifyCode: 'Verificar Código',
      verifying: 'Verificando...',
      backToLogin: '← Voltar ao login',
      recoverPassword: 'Recuperar Senha',
      enterEmailToRecover: 'Digite seu email para recuperar a senha',
      cancel: 'Cancelar',
      send: 'Enviar',
      sending: 'Enviando...',
      emailSentMessage: 'Se o email existir em nossa base, você receberá instruções para redefinir sua senha.',
    },
    hero: {
      title: 'Transformando Desafios do Setor Minerário em Oportunidades.',
      subtitle: 'A ponte confiável entre mineração responsável e capital global Intermediação e consultoria em ativos minerários com due diligence completo, cadeia de custódia e estruturas financeiras seguras.',
      description: '',
      primaryCta: 'Fale com um especialista',
      secondaryCta: 'Submeta seu lote'
    },
    pillars: {
      title: 'Nossos Pilares de Confiança',
      compliance: {
        title: 'Compliance & Origem',
        description: 'KYC/AML, cadeia de custódia, relatórios auditáveis e aderência às diretrizes OECD.'
      },
      curation: {
        title: 'Curadoria Técnica',
        description: 'Laudos independentes, especificação por lote e parcerias com laboratórios reconhecidos.'
      },
      liquidation: {
        title: 'Liquidação Segura',
        description: 'Escrow, cartas de crédito, seguros especializados e estruturas de pagamento robustas.'
      },
      intelligence: {
        title: 'Inteligência de Mercado',
        description: 'Insights, benchmarks e radar regulatório para decisões estratégicas informadas.'
      }
    },
    solutions: {
      title: 'Nossas Soluções',
      markets: {
        title: 'NexuCapital Markets',
        description: 'Intermediação e negociação especializada em ativos minerários com compradores qualificados globalmente.'
      },
      advisory: {
        title: 'NexuCapital Advisory',
        description: 'Consultoria técnica e regulatória para projetos minerários e estruturação de operações.'
      },
      origins: {
        title: 'NexuCapital Origins',
        description: 'Rastreamento e certificação de origem com cadeia de custódia documentada e auditável.'
      },
      logistics: {
        title: 'NexuCapital Logistics',
        description: 'Cadeia física segura, logística especializada e controle de qualidade em cada etapa.'
      },
      vault: {
        title: 'NexuCapital Vault',
        description: 'Custódia segura, estruturas de escrow e soluções financeiras para liquidação eficiente.'
      },
      insights: {
        title: 'NexuCapital Insights',
        description: 'Inteligência de mercado e publicações especializadas para decisões estratégicas.'
      },
      operations: {
        title: 'NexuCapital Operations',
        description: 'Operação completa de ativos minerários com gestão integrada de recursos.'
      }
    },
    trustSignals: {
      title: 'Comprovações de Confiabilidade',
      kyc: 'KYC/AML/KYB com verificação de sanções e UBO',
      custody: 'Cadeia de custódia documentada e auditável',
      partnerships: 'Parcerias com laboratórios e inspetoras independentes',
      structures: 'Estruturas de escrow/LC e seguros de carga',
      integration: 'Integração com melhores práticas OECD e Processo Kimberley'
    },
    dashboard: {
      welcome: 'Bem-vindo',
      overview: 'Visão Geral',
      profile: 'Perfil',
      settings: 'Configurações',
      logout: 'Sair',
      menu: 'Menu',
      work: 'Trabalho',
      projects: 'Projetos',
      administration: 'Administração',
      users: 'Usuários',
      passwordVault: 'Cofre de Senhas',
      system: 'Sistema',
      tools: 'Ferramentas',
      configuration: 'Configuração',
      chat: 'Chat',
      contact: 'Contato',
      notifications: 'Notificações',
      loading: 'Carregando...',
    },
    about: {
      title: 'A Força por Trás da Mineração Confiável',
      subtitle: 'A NexuCapital nasceu da convicção de que o mercado de ativos minerários precisa de mais do que apenas transações; precisa de confiança. Somos uma equipe de especialistas dedicados a criar pontes seguras entre a origem dos recursos e o capital global, garantindo transparência, compliance e eficiência em cada etapa.',
      mission: 'Nossa Missão',
      vision: 'Nossa Visão',
      values: 'Nossos Valores',
      team: 'Nossa Equipe',
      history: 'Nossa História',
      certifications: 'Certificações',
      partnerships: 'Parcerias',
      advisorsTitle: 'O Nosso Conselho de Especialistas',
      valuesTitle: 'Os Nossos Valores',
      transparency: {
        title: 'Transparência e Ética',
        description: 'Compromisso com compliance, rastreabilidade e práticas ESG.'
      },
      rigor: {
        title: 'Rigor Técnico',
        description: 'Curadoria metalúrgica e gemológica com parceiros certificados.'
      },
      security: {
        title: 'Segurança e Agilidade',
        description: 'Estruturas de liquidação seguras e operações eficientes.'
      },
      longTerm: {
        title: 'Parcerias de Longo Prazo',
        description: 'Construindo um ecossistema de confiança e valor mútuo.'
      }
    },
    legal: {
      privacyPolicy: 'Política de Privacidade',
      termsOfUse: 'Termos de Uso',
      cookiePolicy: 'Política de Cookies',
      legalNotice: 'Aviso Legal',
      lastUpdated: 'Última atualização',
      effectiveDate: 'Data de vigência',
      contactUs: 'Entre em contato',
      dataProtection: 'Proteção de Dados',
      cookies: 'Cookies',
      terms: 'Termos',
      liability: 'Responsabilidade',
      intellectualProperty: 'Propriedade Intelectual',
      termsContent: {
        intro: 'Bem-vindo à NexuCapital. Estes termos definem a sua relação conosco. É importante que você os leia para entender o que pode esperar de nós ao usar nossos serviços, e o que esperamos de você. Ao acessar e utilizar nosso site, você concorda com estes Termos de Uso.',
        section1Title: '1. Nossos Serviços',
        section1Text: 'A NexuCapital é uma plataforma que conecta capital a ativos minerários, oferecendo serviços de intermediação, consultoria, compra, venda, importação e exportação de minerais e pedras preciosas, com foco em compliance, origem certificada e eficiência.',
        section2Title: '2. O que esperamos de você',
        section2Text: 'Ao nos dar permissão para usar nossos serviços, você concorda em seguir estes termos. Você se compromete a:',
        section2Items: [
          'Cumprir as leis aplicáveis e respeitar os direitos de terceiros, incluindo propriedade intelectual e privacidade.',
          'Não abusar, interferir ou interromper nossos serviços, o que inclui a introdução de malware, hacking, falsificação de informações ou qualquer tentativa de contornar nossas medidas de segurança.',
          'Fornecer informações verdadeiras e precisas, especialmente durante os processos de cadastro e due diligence na Área do Cliente.'
        ],
        section3Title: '3. Uso da Área do Cliente e Permissão sobre seu Conteúdo',
        section3Text1: 'Nossos serviços permitem que você faça upload, envie e armazene documentos e informações ("Seu Conteúdo") na Área do Cliente. Você mantém todos os direitos de propriedade intelectual que possui sobre esse conteúdo.',
        section3Text2: 'No entanto, para que possamos operar e prestar nossos serviços, você concede à NexuCapital uma licença para hospedar, reproduzir, distribuir e usar Seu Conteúdo. Esta licença é para o propósito limitado de:',
        section3Items: [
          'Operar e melhorar os serviços, permitindo que a plataforma funcione como projetado.',
          'Desenvolver novas funcionalidades.',
          'Cumprir requisitos legais e de compliance.'
        ],
        section3Text3: 'Você é o único responsável pela legalidade e pelos direitos necessários sobre todo o conteúdo que envia.',
        section4Title: '4. Propriedade Intelectual da NexuCapital',
        section4Text: 'Todo o conteúdo do site, incluindo logotipos, textos, gráficos e o nome "NexuCapital", é de propriedade exclusiva da NexuCapital Empreendimentos LTDA. Você não pode usar nosso nome ou marca sem nossa permissão prévia por escrito.',
        section5Title: '5. Em caso de problemas ou divergências',
        section5_1Title: 'Garantias e Isenção de Responsabilidade',
        section5_1Text: 'Fornecemos nossos serviços com um nível razoável de habilidade e cuidado. No entanto, não fazemos promessas específicas sobre os serviços, exceto o que está expressamente declarado nestes termos.',
        section5_2Title: 'Limitação de Responsabilidade',
        section5_2Text: 'Na medida permitida por lei, a NexuCapital não será responsável por perda de lucros, receitas, oportunidades de negócios ou perdas indiretas ou consequenciais.',
        section6Title: '6. Suspensão ou Rescisão',
        section6Text: 'Reservamo-nos o direito de suspender ou encerrar seu acesso aos serviços se você violar material ou repetidamente estes termos, se formos obrigados por lei, ou se acreditarmos que sua conduta causa dano ou responsabilidade a outros usuários, a terceiros ou a nós.',
        section7Title: '7. Legislação Aplicável e Foro',
        section7Text: 'Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Fica eleito o Foro da Comarca de São Paulo, Estado de São Paulo, para dirimir quaisquer controvérsias.'
      },
      privacyContent: {
        intro: 'A NexuCapital Empreendimentos LTDA ("NexuCapital", "nós", "nosso") leva a sua privacidade e a proteção dos seus dados a sério. Este documento explica como coletamos, usamos, armazenamos e protegemos os dados pessoais dos usuários ("Você") de nosso site e plataforma, em conformidade com a Lei Geral de Proteção de Dados (LGPD).',
        section1Title: '1. Dados que Coletamos',
        section1Text: 'Coletamos informações para fornecer e melhorar nossos serviços:',
        section1Items: [
          'Informações fornecidas por Você: Nome, e-mail, telefone, cargo e empresa através de formulários, e informações profissionais e documentos enviados na Área do Cliente para processos de Due Diligence (KYC/AML).',
          'Informações coletadas automaticamente: Endereço IP, dados do navegador e informações de navegação, coletados através de cookies e tecnologias similares para garantir a segurança e o bom funcionamento da plataforma.'
        ],
        section2Title: '2. Finalidade do Tratamento dos Dados',
        section2Text: 'Utilizamos seus dados para:',
        section2Items: [
          'Prestação de Serviços: Operacionalizar a intermediação, consultoria e gestão de ativos minerários.',
          'Comunicação: Responder às suas solicitações e enviar informações relevantes.',
          'Segurança e Compliance: Realizar verificações de identidade e conformidade, prevenir fraudes e cumprir obrigações legais.',
          'Melhoria da Plataforma: Analisar o uso do nosso site para aprimorar a experiência do usuário.'
        ],
        section3Title: '3. Compartilhamento de Dados',
        section3Text: 'Não comercializamos seus dados. O compartilhamento ocorre apenas quando necessário para a prestação de serviços (com parceiros estratégicos como laboratórios e inspetoras), com prestadores de serviços de tecnologia ou por obrigação legal.',
        section4Title: '4. Segurança dos Dados',
        section4Text: 'Adotamos medidas técnicas e organizacionais rigorosas para proteger seus dados, incluindo criptografia e controle de acesso restrito, em linha com nosso compromisso de rigor e segurança.',
        section5Title: '5. Retenção e Exclusão de Dados',
        section5Text1: 'Mantemos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades para as quais foram coletados, inclusive para fins de cumprimento de quaisquer obrigações legais, contratuais ou de requisição de autoridades competentes.',
        section5Text2: 'Após esse período, os dados são anonimizados ou excluídos de forma segura.',
        section6Title: '6. Seus Direitos como Titular dos Dados',
        section6Text: 'A LGPD garante a Você direitos como confirmação, acesso, correção, anonimização e exclusão de seus dados. Para exercer seus direitos, entre em contato conosco pelo e-mail: privacidade@nexucapital.com.',
        section7Title: '7. Alterações nesta Política',
        section7Text: 'Esta Política de Privacidade pode ser atualizada. Recomendamos que você a revise periodicamente.'
      },
      legalNoticeContent: {
        section1Title: '1. IDENTIFICAÇÃO DA EMPRESA',
        companyName: 'NexuCapital Empreendimentos LTDA',
        tradeName: 'NexuCapital',
        cnpj: '63.929.586/0001-93',
        address: 'R MARIA ANTONIA COTA, 102,LOJA 01 SALA ESC. ADMINISTRATIVO, JOAO MONLEVADE - MG',
        contact: 'contato@nexucapital.com',
        section2Title: '2. PROPRIEDADE INTELECTUAL',
        section2Text: 'O conteúdo integral deste site, incluindo marcas, logotipos, textos e design, é de propriedade da NexuCapital Empreendimentos LTDA e não pode ser reproduzido sem autorização prévia e expressa.',
        section3Title: '3. ISENÇÃO DE RESPONSABILIDADE',
        section3Text: 'As informações apresentadas neste site têm finalidade exclusivamente informativa e não devem ser interpretadas como aconselhamento financeiro, jurídico, de investimento ou de qualquer outra natureza. A NexuCapital não garante a precisão ou completude das informações e se isenta de qualquer responsabilidade por perdas ou danos decorrentes do uso destas.'
      }
    },
    careers: {
      title: 'Trabalhe Conosco',
      subtitle: 'Junte-se a nós em nossa missão de sermos a melhor empresa do mundo em maximização de valor de ativos minerários.',
      heroTitle: 'Venha construir conosco essa história',
      heroSubtitle: 'Junte-se a nós em nossa missão de sermos a melhor empresa do mundo em maximização de valor de ativos minerários.',
      missionTitle: 'Venha construir conosco essa história',
      missionText1: 'Venha fazer parte do time NexuCapital e seja protagonista na transformação do setor de mineração. Nossa equipe é formada por profissionais apaixonados por excelência, inovação e resultados sustentáveis.',
      missionText2: 'Além de se candidatar a uma vaga específica, você pode cadastrar o seu currículo em nosso banco de talentos e ser considerado para futuras oportunidades que se alinhem ao seu perfil e aspirações profissionais.',
      sendResume: 'Enviar Currículo',
      benefits: {
        growth: { title: 'Crescimento Profissional', description: 'Oportunidades de desenvolvimento contínuo e crescimento na carreira em um setor estratégico e em expansão.' },
        team: { title: 'Equipe Colaborativa', description: 'Trabalhe com especialistas multidisciplinares em um ambiente que valoriza a colaboração e o respeito mútuo.' },
        innovation: { title: 'Inovação e Excelência', description: 'Participe de projetos inovadores que estabelecem novos padrões no setor de mineração e ativos minerários.' },
        balance: { title: 'Equilíbrio Vida-Trabalho', description: 'Políticas que promovem o bem-estar e o equilíbrio entre vida pessoal e profissional.' }
      },
      emailSubject: 'Interesse em Trabalhar na NexuCapital',
      emailBody: 'Olá,\n\nTenho interesse em fazer parte da equipe NexuCapital.\n\nInformações sobre minha candidatura:\n- Nome:\n- Área de interesse:\n- Formação:\n- Experiência relevante:\n- LinkedIn:\n\nGostaria de enviar meu currículo e saber mais sobre as oportunidades disponíveis.\n\nAtenciosamente,'
    },
    overview: {
      title: 'Visão Geral da NexuCapital',
      subtitle: 'Construindo a ponte entre mineração responsável e capital global através de transparência, compliance e estruturas financeiras seguras.',
      ourCommitment: 'Nosso Compromisso',
      smartMethodology: 'Metodologia S.M.A.R.T.',
      specific: 'Específico',
      measurable: 'Mensurável',
      achievable: 'Atingível',
      relevant: 'Relevante',
      timeBound: 'Temporal',
      mission: {
        title: 'Nossa Missão',
        text: 'Desbloquear e maximizar o valor de ativos minerários e produtos da mineração, atuando como um parceiro estratégico e inovador para nossos clientes!'
      },
      vision: {
        title: 'Nossa Visão',
        text: 'Ser reconhecida como a escolha prioritária e mais confiável de cada cliente apoiado pela NexuCapital, alcançando o reconhecimento e a confiança de nossos parceiros.'
      },
      valuesTitle: 'Nossos Valores',
      values: {
        financial: { name: 'Maximização de Recursos Financeiros', description: 'Com a NexuCapital, seu ativo minerário se transforma em valor. Através de estratégias inteligentes e execução impecável, maximizamos o potencial financeiro de cada projeto, garantindo retornos superiores e duradouros para seu investimento.' },
        human: { name: 'Respeito Humanizado no Tratamento', description: 'Na NexuCapital, o futuro da mineração é construído com pessoas. Priorizamos o respeito humanizado e a ética em cada interação, garantindo um ambiente justo e colaborativo para todos os envolvidos, desde a prospecção até a comercialização.' },
        trust: { name: 'Confiabilidade e Transparência', description: 'Sua confiança é o nosso maior ativo. A NexuCapital opera com transparência total e processos rigorosos, assegurando clareza, segurança jurídica e previsibilidade em todas as nossas operações e negociações.' },
        success: { name: 'Sucesso Focado no Cliente', description: 'O seu sucesso é a nossa missão. A NexuCapital é a parceira estratégica que transforma seus objetivos mais ambiciosos em conquistas reais e mensuráveis, impulsionando resultados extraordinários na mineração.' },
        integrated: { name: 'Valor Integrado', description: 'Na NexuCapital, unimos expertise e valores. Entregamos soluções completas que geram valor financeiro máximo, pautadas pelo respeito humano, pela confiabilidade e pela transparência, garantindo um sucesso sustentável em cada empreendimento minerário.' }
      },
      approach: {
        title: 'Nossa Abordagem',
        intro: 'Nossa abordagem transcende a simples prestação de serviços; ela é uma parceria estratégica e meticulosamente planejada, concebida para desmistificar e otimizar cada etapa do ciclo de valor dos ativos minerários. Compreendemos a complexidade do setor e a necessidade de uma execução precisa e orientada a resultados. Por isso, nossa metodologia é intrinsecamente S.M.A.R.T., garantindo que cada ação seja Específica, Mensurável, Alcançável, Relevante e com Prazo Definido (Time-bound), visando o sucesso inquestionável de nossos clientes e a sustentabilidade de suas operações.',
        footer: 'A abordagem S.M.A.R.T. aplicada na lógica de negócio da NexuCapital não é apenas uma promessa, mas uma metodologia operacional que fundamenta cada decisão e ação, garantindo que o seu sucesso seja o nosso sucesso.',
        footerEmphasis: 'Alcançado com transparência, responsabilidade e excelência.'
      },
      smart: {
        specific: {
          title: 'Específica (Specific)',
          subtitle: 'A Precisão como Alicerce',
          items: [
            'Foco cirúrgico no setor de mineração, com serviços detalhados.',
            'Conformidade inegociável com licenciamentos e registros essenciais.',
            'Otimização tributária precisa para maximização de recursos.'
          ]
        },
        measurable: {
          title: 'Mensurável (Measurable)',
          subtitle: 'O Progresso em Números',
          items: [
            { title: 'Ganhos Financeiros:', description: 'Maximização de recursos com otimização de custos, rentabilidade e métricas claras de desempenho.' },
            { title: 'Compliance Auditável:', description: 'Controle digital e rastreabilidade para auditoria constante e minimização de riscos.' },
            { title: 'Reconhecimento do Cliente:', description: 'Medido por satisfação, retenção e negócios recorrentes para garantir a confiança.' },
            { title: 'Eficiência Operacional:', description: 'Redução de prazos e otimização de fluxos para impactar positivamente tempo e custo.' }
          ]
        },
        achievable: {
          title: 'Alcançável (Achievable)',
          subtitle: 'Estratégia e Expertise',
          items: [
            'Equipe multidisciplinar com expertise legal, fiscal e operacional.',
            'Processos validados e um caminho claro para a operação.',
            'Flexibilidade para adaptação às dinâmicas do mercado.'
          ]
        },
        relevant: {
          title: 'Relevante (Relevant)',
          subtitle: 'Impacto e Valor no Negócio',
          items: [
            'Parceiro estratégico em um setor de alta regulação.',
            'Mitigação de riscos legais e operacionais para proteger investimentos.',
            'Criação de valor sustentável e de longo prazo.'
          ]
        },
        timeBound: {
          title: 'Prazo Definido (Time-bound)',
          subtitle: 'Compromisso com a Agilidade',
          items: [
            'Prazos claros e gestão de tempo para entrega pontual.',
            'Ciclos de otimização contínuos com ajustes rápidos.',
            'Respostas ágeis para garantir operações sem atrasos.'
          ]
        }
      }
    },
    board: {
      title: 'Estrutura Organizacional',
      subtitle: 'Equipe especializada com expertise em comércio de minerais, compliance regulatório e operações de comércio exterior.'
    },
    strategy: {
      title: 'Estratégia de Negócios',
      subtitle: 'Estratégia focada em excelência operacional, conformidade regulatória e crescimento sustentável no mercado de minerais e metais.',
      businessModel: 'Modelo de Negócios'
    },
    governance: {
      title: 'Governança Corporativa',
      subtitle: 'Desenvolvimento de estrutura de governança sólida focada em compliance regulatório e transparência nas operações de comércio de minerais e metais.',
      ourCommitment: 'Nosso compromisso',
      principlesTitle: 'Princípios de Governança',
      regulatoryCompliance: 'Compliance Regulatório',
      operationalTransparency: 'Transparência Operacional',
      riskManagement: 'Gestão de Riscos',
      integrity: 'Integridade'
    },
    router: {
      comingSoon: 'Esta seção estará disponível em breve.',
      documentation: 'Documentação',
      support: 'Suporte Técnico',
      partnerships: 'Parcerias',
      insights: 'Insights & Análises',
      backToHome: 'Voltar ao Início',
      contactUs: 'Entre em Contato'
    },
    footer: {
      company: 'NexuCapital',
      description: 'Intermediação confiável em ativos minerários com due diligence completo, cadeia de custódia certificada e estruturas financeiras seguras.',
      solutions: {
        title: 'Soluções',
        markets: 'NexuCapital Markets',
        advisory: 'NexuCapital Advisory',
        origins: 'NexuCapital Origins',
        logistics: 'NexuCapital Logistics',
        vault: 'NexuCapital Vault',
        operations: 'NexuCapital Operations',
        insights: 'NexuCapital Insights'
      },
      resources: {
        title: 'Recursos',
        documentation: 'Documentação',
        compliance: 'Compliance',
        insights: 'Market Insights',
        support: 'Suporte'
      },
      company_info: {
        title: 'Empresa',
        about: 'Sobre Nós',
        careers: 'Carreiras',
        partnerships: 'Parcerias',
        news: 'Notícias'
      },
      contact: {
        title: 'Contato',
        email: 'contato@nexucapital.com.br',
        phone: '+55 (31) 98413-2603',
        address: 'Belo Horizonte, Brasil',
        business_hours: 'Seg-Sex: 9h às 18h'
      },
      legal: {
        privacy: 'Política de Privacidade',
        terms: 'Termos de Uso',
        cookies: 'Política de Cookies',
        disclaimer: 'Aviso Legal'
      },
      social: {
        linkedin: 'LinkedIn',
        x: 'X',
        instagram: 'Instagram'
      },
      certifications: {
        title: 'Certificações',
        iso: 'ISO 9001:2015',
        oecd: 'OECD Guidelines',
        kimberley: 'Kimberley Process'
      },
      copyright: '© 2025 NexuCapital Empreendimentos LTDA. Todos os direitos reservados.'
    }
  },
  'en': {
    navigation: {
      home: 'Home',
      solutions: 'Solutions',
      assets: 'Assets',
      compliance: 'Compliance',
      insights: 'Insights',
      about: 'About',
      contact: 'Contact',
      blog: 'Blog',
      press: 'Press',
      clientArea: 'Client Area',
      login: 'Login',
      ourSolutions: 'Our Solutions',
      generalServices: 'General Services',
      consulting: 'General Consulting',
      support: 'Technical Support',
      training: 'Training',
      documentation: 'Documentation',
      api: 'API & Integration',
      partnerships: 'Partnerships',
      aboutSubmenu: {
        overview: 'Overview',
        board: 'Board',
        strategy: 'Strategy',
        governance: 'Corporate Governance',
      },
    },
    auth: {
      clientArea: 'Client Area',
      accessAccount: 'Access your account',
      email: 'Email',
      password: 'Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot my password',
      login: 'Sign In',
      loggingIn: 'Signing In...',
      continue: 'Continue',
      notMe: 'Not me',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      backToWebsite: '← Back to website',
      twoFactorVerification: 'Two-Factor Authentication',
      enterCodeFromAuth: 'Enter the code from your authenticator app',
      verificationCode: 'Verification Code',
      verifyCode: 'Verify Code',
      verifying: 'Verifying...',
      backToLogin: '← Back to login',
      recoverPassword: 'Recover Password',
      enterEmailToRecover: 'Enter your email to recover password',
      cancel: 'Cancel',
      send: 'Send',
      sending: 'Sending...',
      emailSentMessage: 'If the email exists in our database, you will receive instructions to reset your password.',
    },
    hero: {
      title: 'Turning Mining Industry Challenges into Opportunities',
      subtitle: 'The trusted bridge between responsible mining and global capital',
      description: 'Mining asset intermediation and consulting with complete due diligence, chain of custody, and secure financial structures.',
      primaryCta: 'Talk to a specialist',
      secondaryCta: 'Submit your lot'
    },
    pillars: {
      title: 'Our Trust Pillars',
      compliance: {
        title: 'Compliance & Origin',
        description: 'KYC/AML, chain of custody, auditable reports, and adherence to OECD guidelines.'
      },
      curation: {
        title: 'Technical Curation',
        description: 'Independent reports, lot specification, and partnerships with recognized laboratories.'
      },
      liquidation: {
        title: 'Secure Settlement',
        description: 'Escrow, letters of credit, specialized insurance, and robust payment structures.'
      },
      intelligence: {
        title: 'Market Intelligence',
        description: 'Insights, benchmarks, and regulatory radar for informed strategic decisions.'
      }
    },
    solutions: {
      title: 'Our Solutions',
      markets: {
        title: 'NexuCapital Markets',
        description: 'Specialized intermediation and trading in mining assets with globally qualified buyers.'
      },
      advisory: {
        title: 'NexuCapital Advisory',
        description: 'Technical and regulatory consulting for mining projects and operation structuring.'
      },
      origins: {
        title: 'NexuCapital Origins',
        description: 'Origin tracking and certification with documented and auditable chain of custody.'
      },
      logistics: {
        title: 'NexuCapital Logistics',
        description: 'Secure physical chain, specialized logistics, and quality control at every stage.'
      },
      vault: {
        title: 'NexuCapital Vault',
        description: 'Secure custody, escrow structures, and financial solutions for efficient settlement.'
      },
      insights: {
        title: 'NexuCapital Insights',
        description: 'Market intelligence and specialized publications for strategic decisions.'
      },
      operations: {
        title: 'NexuCapital Operations',
        description: 'Complete operation of mining assets with integrated resource management.'
      }
    },
    trustSignals: {
      title: 'Trust Proofs',
      kyc: 'KYC/AML/KYB with sanctions verification and UBO',
      custody: 'Documented and auditable chain of custody',
      partnerships: 'Partnerships with independent laboratories and inspectors',
      structures: 'Escrow/LC structures and cargo insurance',
      integration: 'Integration with OECD best practices and Kimberley Process'
    },
    dashboard: {
      welcome: 'Welcome',
      overview: 'Overview',
      profile: 'Profile',
      settings: 'Settings',
      logout: 'Logout',
      menu: 'Menu',
      work: 'Work',
      projects: 'Projects',
      administration: 'Administration',
      users: 'Users',
      passwordVault: 'Password Vault',
      system: 'System',
      tools: 'Tools',
      configuration: 'Configuration',
      chat: 'Chat',
      contact: 'Contact',
      notifications: 'Notifications',
      loading: 'Loading...',
    },
    about: {
      title: 'The Force Behind Reliable Mining',
      subtitle: 'NexuCapital was born from the conviction that the mining assets market needs more than just transactions; it needs trust. We are a team of specialists dedicated to creating secure bridges between resource origins and global capital, ensuring transparency, compliance and efficiency at every step.',
      mission: 'Our Mission',
      vision: 'Our Vision',
      values: 'Our Values',
      team: 'Our Team',
      history: 'Our History',
      certifications: 'Certifications',
      partnerships: 'Partnerships',
      advisorsTitle: 'Our Advisory Board',
      valuesTitle: 'Our Values',
      transparency: {
        title: 'Transparency and Ethics',
        description: 'Commitment to compliance, traceability and ESG practices.'
      },
      rigor: {
        title: 'Technical Rigor',
        description: 'Metallurgical and gemological curation with certified partners.'
      },
      security: {
        title: 'Security and Agility',
        description: 'Secure settlement structures and efficient operations.'
      },
      longTerm: {
        title: 'Long-Term Partnerships',
        description: 'Building an ecosystem of trust and mutual value.'
      }
    },
    legal: {
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      cookiePolicy: 'Cookie Policy',
      legalNotice: 'Legal Notice',
      lastUpdated: 'Last updated',
      effectiveDate: 'Effective date',
      contactUs: 'Contact us',
      dataProtection: 'Data Protection',
      cookies: 'Cookies',
      terms: 'Terms',
      liability: 'Liability',
      intellectualProperty: 'Intellectual Property',
      termsContent: {
        intro: 'Welcome to NexuCapital. These terms define your relationship with us. It is important that you read them to understand what you can expect from us when using our services, and what we expect from you. By accessing and using our website, you agree to these Terms of Use.',
        section1Title: '1. Our Services',
        section1Text: 'NexuCapital is a platform that connects capital to mining assets, offering intermediation, consulting, buying, selling, import and export services for minerals and precious stones, with a focus on compliance, certified origin and efficiency.',
        section2Title: '2. What We Expect From You',
        section2Text: 'By giving us permission to use our services, you agree to follow these terms. You commit to:',
        section2Items: [
          'Comply with applicable laws and respect the rights of third parties, including intellectual property and privacy.',
          'Not abuse, interfere with or interrupt our services, which includes introducing malware, hacking, falsifying information or any attempt to circumvent our security measures.',
          'Provide true and accurate information, especially during registration and due diligence processes in the Client Area.'
        ],
        section3Title: '3. Use of Client Area and Permission Over Your Content',
        section3Text1: 'Our services allow you to upload, submit and store documents and information ("Your Content") in the Client Area. You retain all intellectual property rights you have over this content.',
        section3Text2: 'However, in order for us to operate and provide our services, you grant NexuCapital a license to host, reproduce, distribute and use Your Content. This license is for the limited purpose of:',
        section3Items: [
          'Operating and improving the services, allowing the platform to function as designed.',
          'Developing new features.',
          'Meeting legal and compliance requirements.'
        ],
        section3Text3: 'You are solely responsible for the legality and necessary rights over all content you submit.',
        section4Title: '4. NexuCapital Intellectual Property',
        section4Text: 'All website content, including logos, texts, graphics and the name "NexuCapital", is the exclusive property of NexuCapital Empreendimentos LTDA. You may not use our name or brand without our prior written permission.',
        section5Title: '5. In Case of Problems or Disputes',
        section5_1Title: 'Warranties and Disclaimer',
        section5_1Text: 'We provide our services with a reasonable level of skill and care. However, we make no specific promises about the services, except as expressly stated in these terms.',
        section5_2Title: 'Limitation of Liability',
        section5_2Text: 'To the extent permitted by law, NexuCapital will not be liable for loss of profits, revenue, business opportunities or indirect or consequential losses.',
        section6Title: '6. Suspension or Termination',
        section6Text: 'We reserve the right to suspend or terminate your access to services if you materially or repeatedly violate these terms, if required by law, or if we believe your conduct causes harm or liability to other users, third parties or us.',
        section7Title: '7. Applicable Law and Jurisdiction',
        section7Text: 'These Terms of Use are governed by the laws of the Federative Republic of Brazil. The Court of São Paulo, State of São Paulo, is elected to resolve any disputes.'
      },
      privacyContent: {
        intro: 'NexuCapital Empreendimentos LTDA ("NexuCapital", "we", "our") takes your privacy and data protection seriously. This document explains how we collect, use, store and protect the personal data of users ("You") of our website and platform, in compliance with the General Data Protection Law (LGPD).',
        section1Title: '1. Data We Collect',
        section1Text: 'We collect information to provide and improve our services:',
        section1Items: [
          'Information provided by You: Name, email, phone, position and company through forms, and professional information and documents submitted in the Client Area for Due Diligence (KYC/AML) processes.',
          'Automatically collected information: IP address, browser data and browsing information, collected through cookies and similar technologies to ensure the security and proper functioning of the platform.'
        ],
        section2Title: '2. Purpose of Data Processing',
        section2Text: 'We use your data for:',
        section2Items: [
          'Service Provision: Operating intermediation, consulting and mining asset management.',
          'Communication: Responding to your requests and sending relevant information.',
          'Security and Compliance: Performing identity and compliance checks, preventing fraud and meeting legal obligations.',
          'Platform Improvement: Analyzing the use of our website to enhance user experience.'
        ],
        section3Title: '3. Data Sharing',
        section3Text: 'We do not sell your data. Sharing occurs only when necessary for service provision (with strategic partners such as laboratories and inspectors), with technology service providers or by legal obligation.',
        section4Title: '4. Data Security',
        section4Text: 'We adopt rigorous technical and organizational measures to protect your data, including encryption and restricted access control, in line with our commitment to rigor and security.',
        section5Title: '5. Data Retention and Deletion',
        section5Text1: 'We keep your personal data only for as long as necessary to fulfill the purposes for which it was collected, including for compliance with any legal, contractual obligations or requests from competent authorities.',
        section5Text2: 'After this period, data is anonymized or securely deleted.',
        section6Title: '6. Your Rights as Data Subject',
        section6Text: 'The LGPD guarantees you rights such as confirmation, access, correction, anonymization and deletion of your data. To exercise your rights, contact us at: privacy@nexucapital.com.',
        section7Title: '7. Changes to This Policy',
        section7Text: 'This Privacy Policy may be updated. We recommend that you review it periodically.'
      },
      legalNoticeContent: {
        section1Title: '1. COMPANY IDENTIFICATION',
        companyName: 'NexuCapital Empreendimentos LTDA',
        tradeName: 'NexuCapital',
        cnpj: '63.929.586/0001-93',
        address: 'R MARIA ANTONIA COTA, 102,LOJA 01 SALA ESC. ADMINISTRATIVO, JOAO MONLEVADE - MG',
        contact: 'contato@nexucapital.com',
        section2Title: '2. INTELLECTUAL PROPERTY',
        section2Text: 'The entire content of this website, including trademarks, logos, texts and design, is the property of NexuCapital Empreendimentos LTDA and may not be reproduced without prior and express authorization.',
        section3Title: '3. DISCLAIMER',
        section3Text: 'The information presented on this website is for informational purposes only and should not be interpreted as financial, legal, investment or any other type of advice. NexuCapital does not guarantee the accuracy or completeness of the information and disclaims any liability for losses or damages arising from its use.'
      }
    },
    careers: {
      title: 'Work With Us',
      subtitle: 'Join us in our mission to be the world\'s best company in mining asset value maximization.',
      heroTitle: 'Come build this story with us',
      heroSubtitle: 'Join us in our mission to be the world\'s best company in mining asset value maximization.',
      missionTitle: 'Come build this story with us',
      missionText1: 'Join the NexuCapital team and be a protagonist in the transformation of the mining sector. Our team is formed by professionals passionate about excellence, innovation and sustainable results.',
      missionText2: 'In addition to applying for a specific position, you can register your resume in our talent bank and be considered for future opportunities that align with your profile and professional aspirations.',
      sendResume: 'Send Resume',
      benefits: {
        growth: { title: 'Professional Growth', description: 'Opportunities for continuous development and career growth in a strategic and expanding sector.' },
        team: { title: 'Collaborative Team', description: 'Work with multidisciplinary specialists in an environment that values collaboration and mutual respect.' },
        innovation: { title: 'Innovation and Excellence', description: 'Participate in innovative projects that set new standards in the mining and mineral assets sector.' },
        balance: { title: 'Work-Life Balance', description: 'Policies that promote well-being and balance between personal and professional life.' }
      },
      emailSubject: 'Interest in Working at NexuCapital',
      emailBody: 'Hello,\\n\\nI am interested in joining the NexuCapital team.\\n\\nInformation about my application:\\n- Name:\\n- Area of interest:\\n- Education:\\n- Relevant experience:\\n- LinkedIn:\\n\\nI would like to submit my resume and learn more about available opportunities.\\n\\nBest regards,'
    },
    overview: {
      title: 'NexuCapital Overview',
      subtitle: 'Building the bridge between responsible mining and global capital through transparency, compliance and secure financial structures.',
      ourCommitment: 'Our Commitment',
      smartMethodology: 'S.M.A.R.T. Methodology',
      specific: 'Specific',
      measurable: 'Measurable',
      achievable: 'Achievable',
      relevant: 'Relevant',
      timeBound: 'Time-Bound',
      mission: {
        title: 'Our Mission',
        text: 'Unlock and maximize the value of mining assets and mining products, acting as a strategic and innovative partner for our clients!'
      },
      vision: {
        title: 'Our Vision',
        text: 'To be recognized as the priority and most reliable choice of each client supported by NexuCapital, achieving the recognition and trust of our partners.'
      },
      valuesTitle: 'Our Values',
      values: {
        financial: { name: 'Financial Resource Maximization', description: 'With NexuCapital, your mining asset transforms into value. Through intelligent strategies and impeccable execution, we maximize the financial potential of each project, ensuring superior and lasting returns on your investment.' },
        human: { name: 'Humanized Respect in Treatment', description: 'At NexuCapital, the future of mining is built with people. We prioritize humanized respect and ethics in every interaction, ensuring a fair and collaborative environment for everyone involved, from prospecting to commercialization.' },
        trust: { name: 'Reliability and Transparency', description: 'Your trust is our greatest asset. NexuCapital operates with total transparency and rigorous processes, ensuring clarity, legal security and predictability in all our operations and negotiations.' },
        success: { name: 'Client-Focused Success', description: 'Your success is our mission. NexuCapital is the strategic partner that transforms your most ambitious goals into real and measurable achievements, driving extraordinary results in mining.' },
        integrated: { name: 'Integrated Value', description: 'At NexuCapital, we unite expertise and values. We deliver complete solutions that generate maximum financial value, guided by human respect, reliability and transparency, ensuring sustainable success in every mining venture.' }
      },
      approach: {
        title: 'Our Approach',
        intro: 'Our approach transcends simple service provision; it is a strategic and meticulously planned partnership, designed to demystify and optimize each stage of the mining asset value cycle. We understand the complexity of the sector and the need for precise, results-oriented execution. Therefore, our methodology is intrinsically S.M.A.R.T., ensuring that each action is Specific, Measurable, Achievable, Relevant and Time-bound, aiming for the unquestionable success of our clients and the sustainability of their operations.',
        footer: 'The S.M.A.R.T. approach applied in NexuCapital\'s business logic is not just a promise, but an operational methodology that underlies every decision and action, ensuring that your success is our success.',
        footerEmphasis: 'Achieved with transparency, responsibility and excellence.'
      },
      smart: {
        specific: {
          title: 'Specific',
          subtitle: 'Precision as Foundation',
          items: [
            'Surgical focus on the mining sector, with detailed services.',
            'Non-negotiable compliance with essential licenses and registrations.',
            'Precise tax optimization for resource maximization.'
          ]
        },
        measurable: {
          title: 'Measurable',
          subtitle: 'Progress in Numbers',
          items: [
            { title: 'Financial Gains:', description: 'Resource maximization with cost optimization, profitability and clear performance metrics.' },
            { title: 'Auditable Compliance:', description: 'Digital control and traceability for constant auditing and risk minimization.' },
            { title: 'Client Recognition:', description: 'Measured by satisfaction, retention and recurring business to ensure trust.' },
            { title: 'Operational Efficiency:', description: 'Deadline reduction and flow optimization to positively impact time and cost.' }
          ]
        },
        achievable: {
          title: 'Achievable',
          subtitle: 'Strategy and Expertise',
          items: [
            'Multidisciplinary team with legal, fiscal and operational expertise.',
            'Validated processes and a clear path to operation.',
            'Flexibility to adapt to market dynamics.'
          ]
        },
        relevant: {
          title: 'Relevant',
          subtitle: 'Impact and Business Value',
          items: [
            'Strategic partner in a highly regulated sector.',
            'Mitigation of legal and operational risks to protect investments.',
            'Creation of sustainable, long-term value.'
          ]
        },
        timeBound: {
          title: 'Time-Bound',
          subtitle: 'Commitment to Agility',
          items: [
            'Clear deadlines and time management for punctual delivery.',
            'Continuous optimization cycles with quick adjustments.',
            'Agile responses to ensure operations without delays.'
          ]
        }
      }
    },
    board: {
      title: 'Organizational Structure',
      subtitle: 'Specialized team with expertise in mineral trading, regulatory compliance and foreign trade operations.'
    },
    strategy: {
      title: 'Business Strategy',
      subtitle: 'Strategy focused on operational excellence, regulatory compliance and sustainable growth in the minerals and metals market.',
      businessModel: 'Business Model'
    },
    governance: {
      title: 'Corporate Governance',
      subtitle: 'Development of solid governance structure focused on regulatory compliance and transparency in mineral and metal trading operations.',
      ourCommitment: 'Our commitment',
      principlesTitle: 'Governance Principles',
      regulatoryCompliance: 'Regulatory Compliance',
      operationalTransparency: 'Operational Transparency',
      riskManagement: 'Risk Management',
      integrity: 'Integrity'
    },
    router: {
      comingSoon: 'This section will be available soon.',
      documentation: 'Documentation',
      support: 'Technical Support',
      partnerships: 'Partnerships',
      insights: 'Insights & Analysis',
      backToHome: 'Back to Home',
      contactUs: 'Contact Us'
    },
    footer: {
      company: 'NexuCapital',
      description: 'Trusted intermediation in mining assets with complete due diligence, certified chain of custody and secure financial structures.',
      solutions: {
        title: 'Solutions',
        markets: 'NexuCapital Markets',
        advisory: 'NexuCapital Advisory',
        origins: 'NexuCapital Origins',
        logistics: 'NexuCapital Logistics',
        vault: 'NexuCapital Vault',
        operations: 'NexuCapital Operations',
        insights: 'NexuCapital Insights'
      },
      resources: {
        title: 'Resources',
        documentation: 'Documentation',
        compliance: 'Compliance',
        insights: 'Market Insights',
        support: 'Support'
      },
      company_info: {
        title: 'Company',
        about: 'About Us',
        careers: 'Careers',
        partnerships: 'Partnerships',
        news: 'News'
      },
      contact: {
        title: 'Contact',
        email: 'contato@nexucapital.com.br',
        phone: '+55 (31)98413-2603',
        address: 'Belo Horizonte, Brazil',
        business_hours: 'Mon-Fri: 9am - 6pm'
      },
      legal: {
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        cookies: 'Cookie Policy',
        disclaimer: 'Legal Disclaimer'
      },
      social: {
        linkedin: 'LinkedIn',
        x: 'X',
        instagram: 'Instagram'
      },
      certifications: {
        title: 'Certifications',
        iso: 'ISO 9001:2015',
        oecd: 'OECD Guidelines',
        kimberley: 'Kimberley Process'
      },
      copyright: '© 2025 NexuCapital Empreendimentos LTDA. All rights reserved.'
    }
  },
  'es': {
    navigation: {
      home: 'Inicio',
      solutions: 'Soluciones',
      assets: 'Activos',
      compliance: 'Cumplimiento',
      insights: 'Análisis',
      about: 'Acerca',
      contact: 'Contacto',
      blog: 'Blog',
      press: 'Prensa',
      clientArea: 'Área del Cliente',
      login: 'Iniciar Sesión',
      ourSolutions: 'Nuestras Soluciones',
      generalServices: 'Servicios Generales',
      consulting: 'Consultoría General',
      support: 'Soporte Técnico',
      training: 'Entrenamientos',
      documentation: 'Documentación',
      api: 'API e Integración',
      partnerships: 'Alianzas',
      aboutSubmenu: {
        overview: 'Visión General',
        board: 'Consejo',
        strategy: 'Estrategia',
        governance: 'Gobernanza Corporativa',
      },
    },
    auth: {
      clientArea: 'Área del Cliente',
      accessAccount: 'Accede a tu cuenta',
      email: 'Email',
      password: 'Contraseña',
      rememberMe: 'Recordarme',
      forgotPassword: 'Olvidé mi contraseña',
      login: 'Iniciar Sesión',
      loggingIn: 'Iniciando Sesión...',
      continue: 'Continuar',
      notMe: 'No soy yo',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
      backToWebsite: '← Volver al sitio web',
      twoFactorVerification: 'Verificación de Dos Factores',
      enterCodeFromAuth: 'Ingrese el código de su aplicación autenticadora',
      verificationCode: 'Código de Verificación',
      verifyCode: 'Verificar Código',
      verifying: 'Verificando...',
      backToLogin: '← Volver al login',
      recoverPassword: 'Recuperar Contraseña',
      enterEmailToRecover: 'Ingrese su email para recuperar la contraseña',
      cancel: 'Cancelar',
      send: 'Enviar',
      sending: 'Enviando...',
      emailSentMessage: 'Si el email existe en nuestra base de datos, recibirá instrucciones para restablecer su contraseña.',
    },
    hero: {
      title: 'Transformando Desafíos del Sector Minero en oportunidades',
      subtitle: 'El puente confiable entre minería responsable y capital global',
      description: 'Intermediación y consultoría en activos mineros con due diligence completo, cadena de custodia y estructuras financieras seguras.',
      primaryCta: 'Hablar con especialista',
      secondaryCta: 'Enviar su lote'
    },
    pillars: {
      title: 'Nuestros Pilares de Confianza',
      compliance: {
        title: 'Cumplimiento y Origen',
        description: 'KYC/AML, cadena de custodia, informes auditables y adherencia a directrices OECD.'
      },
      curation: {
        title: 'Curaduría Técnica',
        description: 'Informes independientes, especificación por lote y alianzas con laboratorios reconocidos.'
      },
      liquidation: {
        title: 'Liquidación Segura',
        description: 'Escrow, cartas de crédito, seguros especializados y estructuras de pago robustas.'
      },
      intelligence: {
        title: 'Inteligencia de Mercado',
        description: 'Insights, benchmarks y radar regulatorio para decisiones estratégicas informadas.'
      }
    },
    solutions: {
      title: 'Nuestras Soluciones',
      markets: {
        title: 'NexuCapital Markets',
        description: 'Intermediación y negociación especializada en activos mineros con compradores calificados globalmente.'
      },
      advisory: {
        title: 'NexuCapital Advisory',
        description: 'Consultoría técnica y regulatoria para proyectos mineros y estructuración de operaciones.'
      },
      origins: {
        title: 'NexuCapital Origins',
        description: 'Rastreo y certificación de origen con cadena de custodia documentada y auditable.'
      },
      logistics: {
        title: 'NexuCapital Logistics',
        description: 'Cadena física segura, logística especializada y control de calidad en cada etapa.'
      },
      vault: {
        title: 'NexuCapital Vault',
        description: 'Custodia segura, estructuras de escrow y soluciones financieras para liquidación eficiente.'
      },
      insights: {
        title: 'NexuCapital Insights',
        description: 'Inteligencia de mercado y publicaciones especializadas para decisiones estratégicas.'
      },
      operations: {
        title: 'NexuCapital Operations',
        description: 'Operación completa de activos mineros con gestión integrada de recursos.'
      }
    },
    trustSignals: {
      title: 'Pruebas de Confiabilidad',
      kyc: 'KYC/AML/KYB con verificación de sanciones y UBO',
      custody: 'Cadena de custodia documentada y auditable',
      partnerships: 'Alianzas con laboratorios e inspectores independientes',
      structures: 'Estructuras de escrow/LC y seguros de carga',
      integration: 'Integración con mejores prácticas OECD y Proceso Kimberley'
    },
    dashboard: {
      welcome: 'Bienvenido',
      overview: 'Resumen',
      profile: 'Perfil',
      settings: 'Configuración',
      logout: 'Cerrar Sesión',
      menu: 'Menú',
      work: 'Trabajo',
      projects: 'Proyectos',
      administration: 'Administración',
      users: 'Usuarios',
      passwordVault: 'Bóveda de Contraseñas',
      system: 'Sistema',
      tools: 'Herramientas',
      configuration: 'Configuración',
      chat: 'Chat',
      contact: 'Contacto',
      notifications: 'Notificaciones',
      loading: 'Cargando...',
    },
    about: {
      title: 'La Fuerza Detrás de la Minería Confiable',
      subtitle: 'NexuCapital nació de la convicción de que el mercado de activos mineros necesita más que solo transacciones; necesita confianza. Somos un equipo de especialistas dedicados a crear puentes seguros entre el origen de los recursos y el capital global, garantizando transparencia, cumplimiento y eficiencia en cada paso.',
      mission: 'Nuestra Misión',
      vision: 'Nuestra Visión',
      values: 'Nuestros Valores',
      team: 'Nuestro Equipo',
      history: 'Nuestra Historia',
      certifications: 'Certificaciones',
      partnerships: 'Alianzas',
      advisorsTitle: 'Nuestro Consejo Asesor',
      valuesTitle: 'Nuestros Valores',
      transparency: {
        title: 'Transparencia y Ética',
        description: 'Compromiso con el cumplimiento, trazabilidad y prácticas ESG.'
      },
      rigor: {
        title: 'Rigor Técnico',
        description: 'Curaduría metalúrgica y gemológica con socios certificados.'
      },
      security: {
        title: 'Seguridad y Agilidad',
        description: 'Estructuras de liquidación seguras y operaciones eficientes.'
      },
      longTerm: {
        title: 'Alianzas a Largo Plazo',
        description: 'Construyendo un ecosistema de confianza y valor mutuo.'
      }
    },
    legal: {
      privacyPolicy: 'Política de Privacidad',
      termsOfUse: 'Términos de Uso',
      cookiePolicy: 'Política de Cookies',
      legalNotice: 'Aviso Legal',
      lastUpdated: 'Última actualización',
      effectiveDate: 'Fecha de vigencia',
      contactUs: 'Contáctanos',
      dataProtection: 'Protección de Datos',
      cookies: 'Cookies',
      terms: 'Términos',
      liability: 'Responsabilidad',
      intellectualProperty: 'Propiedad Intelectual',
      termsContent: {
        intro: 'Bienvenido a NexuCapital. Estos términos definen su relación con nosotros. Es importante que los lea para entender qué puede esperar de nosotros al usar nuestros servicios, y qué esperamos de usted. Al acceder y utilizar nuestro sitio, acepta estos Términos de Uso.',
        section1Title: '1. Nuestros Servicios',
        section1Text: 'NexuCapital es una plataforma que conecta capital con activos mineros, ofreciendo servicios de intermediación, consultoría, compra, venta, importación y exportación de minerales y piedras preciosas, con enfoque en cumplimiento, origen certificado y eficiencia.',
        section2Title: '2. Lo Que Esperamos de Usted',
        section2Text: 'Al darnos permiso para usar nuestros servicios, acepta seguir estos términos. Usted se compromete a:',
        section2Items: [
          'Cumplir con las leyes aplicables y respetar los derechos de terceros, incluyendo propiedad intelectual y privacidad.',
          'No abusar, interferir o interrumpir nuestros servicios, lo que incluye la introducción de malware, hacking, falsificación de información o cualquier intento de eludir nuestras medidas de seguridad.',
          'Proporcionar información veraz y precisa, especialmente durante los procesos de registro y due diligence en el Área del Cliente.'
        ],
        section3Title: '3. Uso del Área del Cliente y Permiso sobre su Contenido',
        section3Text1: 'Nuestros servicios le permiten cargar, enviar y almacenar documentos e información ("Su Contenido") en el Área del Cliente. Usted conserva todos los derechos de propiedad intelectual que posee sobre este contenido.',
        section3Text2: 'Sin embargo, para que podamos operar y prestar nuestros servicios, usted otorga a NexuCapital una licencia para alojar, reproducir, distribuir y usar Su Contenido. Esta licencia es para el propósito limitado de:',
        section3Items: [
          'Operar y mejorar los servicios, permitiendo que la plataforma funcione como está diseñada.',
          'Desarrollar nuevas funcionalidades.',
          'Cumplir con requisitos legales y de cumplimiento.'
        ],
        section3Text3: 'Usted es el único responsable de la legalidad y de los derechos necesarios sobre todo el contenido que envía.',
        section4Title: '4. Propiedad Intelectual de NexuCapital',
        section4Text: 'Todo el contenido del sitio, incluyendo logotipos, textos, gráficos y el nombre "NexuCapital", es propiedad exclusiva de NexuCapital Empreendimentos LTDA. No puede usar nuestro nombre o marca sin nuestro permiso previo por escrito.',
        section5Title: '5. En Caso de Problemas o Disputas',
        section5_1Title: 'Garantías y Exención de Responsabilidad',
        section5_1Text: 'Proporcionamos nuestros servicios con un nivel razonable de habilidad y cuidado. Sin embargo, no hacemos promesas específicas sobre los servicios, excepto lo expresamente establecido en estos términos.',
        section5_2Title: 'Limitación de Responsabilidad',
        section5_2Text: 'En la medida permitida por la ley, NexuCapital no será responsable por pérdida de ganancias, ingresos, oportunidades de negocio o pérdidas indirectas o consecuentes.',
        section6Title: '6. Suspensión o Terminación',
        section6Text: 'Nos reservamos el derecho de suspender o terminar su acceso a los servicios si viola material o repetidamente estos términos, si estamos obligados por ley, o si creemos que su conducta causa daño o responsabilidad a otros usuarios, terceros o a nosotros.',
        section7Title: '7. Ley Aplicable y Jurisdicción',
        section7Text: 'Estos Términos de Uso se rigen por las leyes de la República Federativa de Brasil. Se elige el Foro de São Paulo, Estado de São Paulo, para resolver cualquier disputa.'
      },
      privacyContent: {
        intro: 'NexuCapital Empreendimentos LTDA ("NexuCapital", "nosotros", "nuestro") toma en serio su privacidad y la protección de sus datos. Este documento explica cómo recopilamos, usamos, almacenamos y protegemos los datos personales de los usuarios ("Usted") de nuestro sitio web y plataforma, en cumplimiento con la Ley General de Protección de Datos (LGPD).',
        section1Title: '1. Datos que Recopilamos',
        section1Text: 'Recopilamos información para proporcionar y mejorar nuestros servicios:',
        section1Items: [
          'Información proporcionada por Usted: Nombre, email, teléfono, cargo y empresa a través de formularios, e información profesional y documentos enviados en el Área del Cliente para procesos de Due Diligence (KYC/AML).',
          'Información recopilada automáticamente: Dirección IP, datos del navegador e información de navegación, recopilados a través de cookies y tecnologías similares para garantizar la seguridad y el buen funcionamiento de la plataforma.'
        ],
        section2Title: '2. Finalidad del Tratamiento de Datos',
        section2Text: 'Utilizamos sus datos para:',
        section2Items: [
          'Prestación de Servicios: Operar la intermediación, consultoría y gestión de activos mineros.',
          'Comunicación: Responder a sus solicitudes y enviar información relevante.',
          'Seguridad y Cumplimiento: Realizar verificaciones de identidad y cumplimiento, prevenir fraudes y cumplir con obligaciones legales.',
          'Mejora de la Plataforma: Analizar el uso de nuestro sitio para mejorar la experiencia del usuario.'
        ],
        section3Title: '3. Compartir Datos',
        section3Text: 'No comercializamos sus datos. El compartir ocurre solo cuando es necesario para la prestación de servicios (con socios estratégicos como laboratorios e inspectores), con proveedores de servicios tecnológicos o por obligación legal.',
        section4Title: '4. Seguridad de los Datos',
        section4Text: 'Adoptamos medidas técnicas y organizacionales rigurosas para proteger sus datos, incluyendo encriptación y control de acceso restringido, en línea con nuestro compromiso de rigor y seguridad.',
        section5Title: '5. Retención y Eliminación de Datos',
        section5Text1: 'Mantenemos sus datos personales solo por el tiempo necesario para cumplir con los fines para los cuales fueron recopilados, incluyendo el cumplimiento de obligaciones legales, contractuales o solicitudes de autoridades competentes.',
        section5Text2: 'Después de este período, los datos se anonimizan o eliminan de forma segura.',
        section6Title: '6. Sus Derechos como Titular de Datos',
        section6Text: 'La LGPD le garantiza derechos como confirmación, acceso, corrección, anonimización y eliminación de sus datos. Para ejercer sus derechos, contáctenos en: privacidad@nexucapital.com.',
        section7Title: '7. Cambios en esta Política',
        section7Text: 'Esta Política de Privacidad puede ser actualizada. Le recomendamos que la revise periódicamente.'
      },
      legalNoticeContent: {
        section1Title: '1. IDENTIFICACIÓN DE LA EMPRESA',
        companyName: 'NexuCapital Empreendimentos LTDA',
        tradeName: 'NexuCapital',
        cnpj: '63.929.586/0001-93',
        address: 'R MARIA ANTONIA COTA, 102,LOJA 01 SALA ESC. ADMINISTRATIVO, JOAO MONLEVADE - MG',
        contact: 'contato@nexucapital.com',
        section2Title: '2. PROPIEDAD INTELECTUAL',
        section2Text: 'El contenido integral de este sitio web, incluyendo marcas, logotipos, textos y diseño, es propiedad de NexuCapital Empreendimentos LTDA y no puede ser reproducido sin autorización previa y expresa.',
        section3Title: '3. EXENCIÓN DE RESPONSABILIDAD',
        section3Text: 'La información presentada en este sitio web tiene fines exclusivamente informativos y no debe interpretarse como asesoramiento financiero, legal, de inversión o de cualquier otra naturaleza. NexuCapital no garantiza la precisión o integridad de la información y se exime de cualquier responsabilidad por pérdidas o daños derivados de su uso.'
      }
    },
    careers: {
      title: 'Trabaja Con Nosotros',
      subtitle: 'Únete a nuestra misión de ser la mejor empresa del mundo en maximización de valor de activos mineros.',
      heroTitle: 'Ven a construir esta historia con nosotros',
      heroSubtitle: 'Únete a nuestra misión de ser la mejor empresa del mundo en maximización de valor de activos mineros.',
      missionTitle: 'Ven a construir esta historia con nosotros',
      missionText1: 'Únete al equipo NexuCapital y sé protagonista en la transformación del sector minero. Nuestro equipo está formado por profesionales apasionados por la excelencia, innovación y resultados sostenibles.',
      missionText2: 'Además de postularte a una posición específica, puedes registrar tu currículum en nuestro banco de talentos y ser considerado para futuras oportunidades que se alineen con tu perfil y aspiraciones profesionales.',
      sendResume: 'Enviar Currículum',
      benefits: {
        growth: { title: 'Crecimiento Profesional', description: 'Oportunidades de desarrollo continuo y crecimiento profesional en un sector estratégico y en expansión.' },
        team: { title: 'Equipo Colaborativo', description: 'Trabaja con especialistas multidisciplinarios en un ambiente que valora la colaboración y el respeto mutuo.' },
        innovation: { title: 'Innovación y Excelencia', description: 'Participa en proyectos innovadores que establecen nuevos estándares en el sector minero y de activos minerales.' },
        balance: { title: 'Equilibrio Vida-Trabajo', description: 'Políticas que promueven el bienestar y el equilibrio entre la vida personal y profesional.' }
      },
      emailSubject: 'Interés en Trabajar en NexuCapital',
      emailBody: 'Hola,\\n\\nEstoy interesado en formar parte del equipo NexuCapital.\\n\\nInformación sobre mi candidatura:\\n- Nombre:\\n- Área de interés:\\n- Formación:\\n- Experiencia relevante:\\n- LinkedIn:\\n\\nMe gustaría enviar mi currículum y conocer más sobre las oportunidades disponibles.\\n\\nAtentamente,'
    },
    overview: {
      title: 'Visión General de NexuCapital',
      subtitle: 'Construyendo el puente entre minería responsable y capital global a través de transparencia, cumplimiento y estructuras financieras seguras.',
      ourCommitment: 'Nuestro Compromiso',
      smartMethodology: 'Metodología S.M.A.R.T.',
      specific: 'Específico',
      measurable: 'Medible',
      achievable: 'Alcanzable',
      relevant: 'Relevante',
      timeBound: 'Temporal',
      mission: {
        title: 'Nuestra Misión',
        text: '¡Desbloquear y maximizar el valor de activos mineros y productos de minería, actuando como un socio estratégico e innovador para nuestros clientes!'
      },
      vision: {
        title: 'Nuestra Visión',
        text: 'Ser reconocida como la opción prioritaria y más confiable de cada cliente apoyado por NexuCapital, logrando el reconocimiento y la confianza de nuestros socios.'
      },
      valuesTitle: 'Nuestros Valores',
      values: {
        financial: { name: 'Maximización de Recursos Financieros', description: 'Con NexuCapital, su activo minero se transforma en valor. A través de estrategias inteligentes y ejecución impecable, maximizamos el potencial financiero de cada proyecto, garantizando retornos superiores y duraderos para su inversión.' },
        human: { name: 'Respeto Humanizado en el Trato', description: 'En NexuCapital, el futuro de la minería se construye con personas. Priorizamos el respeto humanizado y la ética en cada interacción, garantizando un ambiente justo y colaborativo para todos los involucrados, desde la prospección hasta la comercialización.' },
        trust: { name: 'Confiabilidad y Transparencia', description: 'Su confianza es nuestro mayor activo. NexuCapital opera con total transparencia y procesos rigurosos, asegurando claridad, seguridad jurídica y previsibilidad en todas nuestras operaciones y negociaciones.' },
        success: { name: 'Éxito Enfocado en el Cliente', description: 'Su éxito es nuestra misión. NexuCapital es el socio estratégico que transforma sus objetivos más ambiciosos en logros reales y medibles, impulsando resultados extraordinarios en la minería.' },
        integrated: { name: 'Valor Integrado', description: 'En NexuCapital, unimos experiencia y valores. Entregamos soluciones completas que generan valor financiero máximo, guiadas por el respeto humano, la confiabilidad y la transparencia, garantizando un éxito sostenible en cada emprendimiento minero.' }
      },
      approach: {
        title: 'Nuestro Enfoque',
        intro: 'Nuestro enfoque trasciende la simple prestación de servicios; es una asociación estratégica y meticulosamente planificada, diseñada para desmitificar y optimizar cada etapa del ciclo de valor de los activos mineros. Comprendemos la complejidad del sector y la necesidad de una ejecución precisa y orientada a resultados. Por eso, nuestra metodología es intrínsecamente S.M.A.R.T., garantizando que cada acción sea Específica, Medible, Alcanzable, Relevante y con Plazo Definido (Time-bound), buscando el éxito incuestionable de nuestros clientes y la sostenibilidad de sus operaciones.',
        footer: 'El enfoque S.M.A.R.T. aplicado en la lógica de negocios de NexuCapital no es solo una promesa, sino una metodología operacional que fundamenta cada decisión y acción, garantizando que su éxito sea nuestro éxito.',
        footerEmphasis: 'Logrado con transparencia, responsabilidad y excelencia.'
      },
      smart: {
        specific: {
          title: 'Específico',
          subtitle: 'La Precisión como Base',
          items: [
            'Enfoque quirúrgico en el sector minero, con servicios detallados.',
            'Cumplimiento innegociable con licencias y registros esenciales.',
            'Optimización fiscal precisa para maximización de recursos.'
          ]
        },
        measurable: {
          title: 'Medible',
          subtitle: 'El Progreso en Números',
          items: [
            { title: 'Ganancias Financieras:', description: 'Maximización de recursos con optimización de costos, rentabilidad y métricas claras de desempeño.' },
            { title: 'Cumplimiento Auditable:', description: 'Control digital y trazabilidad para auditoría constante y minimización de riesgos.' },
            { title: 'Reconocimiento del Cliente:', description: 'Medido por satisfacción, retención y negocios recurrentes para garantizar la confianza.' },
            { title: 'Eficiencia Operacional:', description: 'Reducción de plazos y optimización de flujos para impactar positivamente tiempo y costo.' }
          ]
        },
        achievable: {
          title: 'Alcanzable',
          subtitle: 'Estrategia y Experiencia',
          items: [
            'Equipo multidisciplinario con experiencia legal, fiscal y operacional.',
            'Procesos validados y un camino claro hacia la operación.',
            'Flexibilidad para adaptarse a las dinámicas del mercado.'
          ]
        },
        relevant: {
          title: 'Relevante',
          subtitle: 'Impacto y Valor en el Negocio',
          items: [
            'Socio estratégico en un sector altamente regulado.',
            'Mitigación de riesgos legales y operacionales para proteger inversiones.',
            'Creación de valor sostenible y a largo plazo.'
          ]
        },
        timeBound: {
          title: 'Plazo Definido',
          subtitle: 'Compromiso con la Agilidad',
          items: [
            'Plazos claros y gestión del tiempo para entrega puntual.',
            'Ciclos de optimización continuos con ajustes rápidos.',
            'Respuestas ágiles para garantizar operaciones sin retrasos.'
          ]
        }
      }
    },
    board: {
      title: 'Estructura Organizacional',
      subtitle: 'Equipo especializado con experiencia en comercio de minerales, cumplimiento regulatorio y operaciones de comercio exterior.'
    },
    strategy: {
      title: 'Estrategia de Negocios',
      subtitle: 'Estrategia enfocada en excelencia operacional, cumplimiento regulatorio y crecimiento sostenible en el mercado de minerales y metales.',
      businessModel: 'Modelo de Negocios'
    },
    governance: {
      title: 'Gobernanza Corporativa',
      subtitle: 'Desarrollo de estructura de gobernanza sólida enfocada en cumplimiento regulatorio y transparencia en las operaciones de comercio de minerales y metales.',
      ourCommitment: 'Nuestro compromiso',
      principlesTitle: 'Principios de Gobernanza',
      regulatoryCompliance: 'Cumplimiento Regulatorio',
      operationalTransparency: 'Transparencia Operacional',
      riskManagement: 'Gestión de Riesgos',
      integrity: 'Integridad'
    },
    router: {
      comingSoon: 'Esta sección estará disponible pronto.',
      documentation: 'Documentación',
      support: 'Soporte Técnico',
      partnerships: 'Alianzas',
      insights: 'Análisis e Insights',
      backToHome: 'Volver al Inicio',
      contactUs: 'Contáctanos'
    },
    footer: {
      company: 'NexuCapital',
      description: 'Intermediación confiable en activos mineros con due diligence completo, cadena de custodia certificada y estructuras financieras seguras.',
      solutions: {
        title: 'Soluciones',
        markets: 'NexuCapital Markets',
        advisory: 'NexuCapital Advisory',
        origins: 'NexuCapital Origins',
        logistics: 'NexuCapital Logistics',
        vault: 'NexuCapital Vault',
        operations: 'NexuCapital Operations',
        insights: 'NexuCapital Insights'
      },
      resources: {
        title: 'Recursos',
        documentation: 'Documentación',
        compliance: 'Cumplimiento',
        insights: 'Análisis de Mercado',
        support: 'Soporte'
      },
      company_info: {
        title: 'Empresa',
        about: 'Acerca de Nosotros',
        careers: 'Carreras',
        partnerships: 'Alianzas',
        news: 'Noticias'
      },
      contact: {
        title: 'Contacto',
        email: 'contato@nexucapital.com.br',
        phone: '+55 (31)98413-2603',
        address: 'Belo Horizonte, Brasil',
        business_hours: 'Lun-Vie: 9h a 18h'
      },
      legal: {
        privacy: 'Política de Privacidad',
        terms: 'Términos de Servicio',
        cookies: 'Política de Cookies',
        disclaimer: 'Aviso Legal'
      },
      social: {
        linkedin: 'LinkedIn',
        x: 'X',
        instagram: 'Instagram'
      },
      certifications: {
        title: 'Certificaciones',
        iso: 'ISO 9001:2015',
        oecd: 'Directrices OCDE',
        kimberley: 'Proceso Kimberley'
      },
      copyright: '© 2025 NexuCapital Empreendimentos LTDA. Todos los derechos reservados.'
    }
  }
};